import styled, { css } from 'styled-components';
import { ornamentTokens } from '../../tokens/components/Ornament/tokens';

const sizes = {
  small: {
    background: ornamentTokens.BackgroundSizeSmallDefault,
  },
  medium: {
    background: ornamentTokens.BackgroundSizeMediumDefault,
  },
  large: {
    background: ornamentTokens.BackgroundSizeLargeDefault,
  },
} as const;

const semanticColors = {
  'feedback-neutral': {
    background: ornamentTokens.BackgroundColorNeutralDefault,
    foreground: ornamentTokens.ForegroundColorNeutralDefault,
  },
  'feedback-positive': {
    background: ornamentTokens.BackgroundColorPositiveDefault,
    foreground: ornamentTokens.ForegroundColorPositiveDefault,
  },
  'feedback-negative': {
    background: ornamentTokens.BackgroundColorNegativeDefault,
    foreground: ornamentTokens.ForegroundColorNegativeDefault,
  },
  'feedback-notice': {
    background: ornamentTokens.BackgroundColorNoticeDefault,
    foreground: ornamentTokens.ForegroundColorNoticeDefault,
  },
  'feedback-pending': {
    background: ornamentTokens.BackgroundColorPendingDefault,
    foreground: ornamentTokens.ForegroundColorPendingDefault,
  },
  'feedback-informational': {
    background: ornamentTokens.BackgroundColorInformationalDefault,
    foreground: ornamentTokens.ForegroundColorInformationalDefault,
  },
  'feedback-staff': {
    background: ornamentTokens.BackgroundColorStaffDefault,
    foreground: ornamentTokens.ForegroundColorStaffDefault,
  },
  'feedback-loading': {
    background: ornamentTokens.BackgroundColorPendingDefault,
    foreground: ornamentTokens.ForegroundColorPendingDefault,
  },
} as const;

const colors = {
  gray: {
    background: ornamentTokens.BackgroundColorGrayDefault,
    foreground: ornamentTokens.ForegroundColorGrayDefault,
  },
  'gray-darker': {
    background: ornamentTokens.BackgroundColorGrayDarkerDefault,
    foreground: ornamentTokens.ForegroundColorGrayDarkerDefault,
  },
  'blue-lightest': {
    background: ornamentTokens.BackgroundColorBlueLightestDefault,
    foreground: ornamentTokens.ForegroundColorBlueLightestDefault,
  },
  'blue-light': {
    background: ornamentTokens.BackgroundColorBlueLightDefault,
    foreground: ornamentTokens.ForegroundColorBlueLightDefault,
  },
  blue: {
    background: ornamentTokens.BackgroundColorBlueDefault,
    foreground: ornamentTokens.ForegroundColorBlueDefault,
  },
  'green-lightest': {
    background: ornamentTokens.BackgroundColorGreenLightestDefault,
    foreground: ornamentTokens.ForegroundColorGreenLightestDefault,
  },
  green: {
    background: ornamentTokens.BackgroundColorGreenDefault,
    foreground: ornamentTokens.ForegroundColorGreenDefault,
  },
  slate: {
    background: ornamentTokens.BackgroundColorSlateDefault,
    foreground: ornamentTokens.ForegroundColorSlateDefault,
  },
  red: {
    background: ornamentTokens.BackgroundColorRedDefault,
    foreground: ornamentTokens.ForegroundColorRedDefault,
  },
  yellow: {
    background: ornamentTokens.BackgroundColorYellowDefault,
    foreground: ornamentTokens.ForegroundColorYellowDefault,
  },
  brown: {
    background: ornamentTokens.BackgroundColorBrownDefault,
    foreground: ornamentTokens.ForegroundColorBrownDefault,
  },
  orange: {
    background: ornamentTokens.BackgroundColorOrangeDefault,
    foreground: ornamentTokens.ForegroundColorOrangeDefault,
  },
  white: {
    background: ornamentTokens.BackgroundColorWhiteDefault,
    foreground: ornamentTokens.ForegroundColorWhiteDefault,
  },
  ...semanticColors,
} as const;

/* @internal */
export const StyledOrnament = styled.div`
  align-items: center;
  background-color: ${({ theme }) => colors[theme.ornamentColor].background};
  border-radius: ${ornamentTokens.BackgroundBorderRadiusBaseDefault};
  display: flex;
  // font-size: ${({ theme }) => sizes[theme.ornamentSize].foreground};
  height: ${({ theme }) => sizes[theme.ornamentSize].background};
  justify-content: center;
  line-height: 1;
  min-width: ${({ theme }) => sizes[theme.ornamentSize].background};
  width: ${({ theme }) => sizes[theme.ornamentSize].background};

  ${({ theme }) => css`
    svg {
      fill: ${colors[theme.ornamentColor].foreground};
      stroke: ${colors[theme.ornamentColor].foreground};
      stroke-width: 0;
    }
  `}

  ${({ theme }) =>
    theme.ornamentInverse &&
    css`
      background: ${ornamentTokens.BackgroundColorWhiteDefault};
      border-width: ${ornamentTokens.BackgroundBorderWidthBaseDefault};
      border-style: ${ornamentTokens.BackgroundBorderStyleInverseDefault};
      border-color: ${colors[theme.ornamentColor].background};
      color: ${colors[theme.ornamentColor].background};

      svg {
        fill: ${colors[theme.ornamentColor].background};
      }
    `}

    ${({ theme }) =>
    theme.ornamentDashed &&
    css`
      background: #ffffff;
      border-width: ${ornamentTokens.BackgroundBorderWidthBaseDefault};
      border-style: ${ornamentTokens.BackgroundBorderStyleDashedDefault};
      border-color: ${colors[theme.ornamentColor].background};
      color: ${colors[theme.ornamentColor].background};

      svg {
        fill: ${colors[theme.ornamentColor].background};
      }
    `}
`;
